import * as React from 'react';

import ArrowForward16 from './ArrowForward16';

export const arrowForward16 = () => <ArrowForward16 />;

export default {
    title: 'Icon/Fill/ArrowForward16',
    component: ArrowForward16,
    parameters: {
        notes: "`import ArrowForward16 from 'box-ui-elements/es/icon/fill/ArrowForward16';`",
    },
};
